import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  wrapper: {
    flex: 1,
    backgroundColor: neutrals.coldGrays.ice,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: brand.main.variations['lighterWater-2'],
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 32,
    marginBottom: 40,
  },
  container: {
    gap: 40,
    alignItems: 'center',
  },
  instructions: {
    gap: 16,
  },
  stepsTitle: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  stepContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    paddingVertical: 16,
  },
  separator: {
    borderTopWidth: 2,
    borderColor: neutrals.white,
  },
  ctaWrapper: {},
  illustration: {
    width: 74,
    height: 74,
  },
  stepsWrapper: {
    alignItems: 'flex-start',
  },
  step: {
    flexDirection: 'row',
    gap: 12,
  },
  stepNumber: {
    fontSize: 30,
    lineHeight: 45,
    fontWeight: 700,
    color: brand.main.water,
    width: 30,
  },
  stepTitle: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  stepDescription: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  cta: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
  },
  ctaIcon: {
    width: 16,
    height: 16,
    padding: 1,
  },
  ctaText: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 700,
    color: brand.main.water,
  },
});
